import { render, staticRenderFns } from "./body-library-table.vue?vue&type=template&id=37b8f969&scoped=true&"
import script from "./body-library-table.vue?vue&type=script&lang=ts&"
export * from "./body-library-table.vue?vue&type=script&lang=ts&"
import style0 from "./body-library-table.vue?vue&type=style&index=0&id=37b8f969&prod&lang=scss&"
import style1 from "./body-library-table.vue?vue&type=style&index=1&id=37b8f969&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8f969",
  null
  
)

export default component.exports